import { types as actions } from 'root/actions';
import { sendAnalyticsUploadEvent } from './analytics.helpers.js';

export const analyticsMiddleware = (store) => (next) => (action) => {
  const analyticsActionTypes = [actions.SET_BATCH_STARTED];

  if (analyticsActionTypes.includes(action.type)) {
    const state = store.getState();
    const { advancedPublicId, advancedTags, advancedUploadPreset, source } = state.widgetData;

    switch (action.type) {
      case actions.SET_BATCH_STARTED:
        sendAnalyticsUploadEvent(source, {
          publicId: advancedPublicId,
          tags: advancedTags,
          preset: advancedUploadPreset,
        });
        break;
      default:
        break;
    }
  }

  next(action);
};
